import service from './axios';

// 会员列表
export const fetchMemberList = (params) => {
  return service({
    method: 'get',
    url: '/manage/member/list',
    params
  });
};

// 会员详情
export const fetchMemberDetail = (id) => {
  return service({
    method: 'get',
    url: `/manage/member/${id}`,
  });
};

// 新增会员
export const addMember = (data) => {
  return service({
    method: 'post',
    url: '/manage/member',
    data
  });
};

// 更新会员
export const updateMember = (id, data) => {
  return service({
    method: 'put',
    url: `/manage/member/${id}`,
    data
  });
};

// 删除会员
export const deleteMember = (id) => {
  return service({
    method: 'delete',
    url: `/manage/member/${id}`,
  });
};

// 更改会员状态
export const updateMemberStatus = (id, status) => {
  return service({
    method: 'put',
    url: `/manage/member/${id}/status`,
    data: { status }
  });
};

// 会员权益列表
export const fetchBenefitList = (params) => {
  return service({
    method: 'get',
    url: '/manage/benefits/list',
    params
  });
};

// 会员权益详情
export const fetchBenefitDetail = (id) => {
  return service({
    method: 'get',
    url: `/manage/benefits/${id}`,
  });
};

// 新增会员权益
export const addBenefit = (data) => {
  return service({
    method: 'post',
    url: '/manage/benefits',
    data
  });
};

// 更新会员权益
export const updateBenefit = (id, data) => {
  return service({
    method: 'put',
    url: `/manage/benefits/${id}`,
    data
  });
};

// 删除会员权益
export const deleteBenefit = (id) => {
  return service({
    method: 'delete',
    url: `/manage/benefits/${id}`,
  });
};

// 更改会员权益状态
export const updateBenefitStatus = (id, status) => {
  return service({
    method: 'patch',
    url: `/manage/benefits/${id}/status`,
    data: { status }
  });
};

// 获取权益图标列表
export const fetchBenefitIcons = () => {
  return service({
    method: 'get',
    url: '/manage/benefits/icons/list'
  });
};

// 会员等级列表
export const fetchMemberLevelList = () => {
  return service({
    method: 'get',
    url: '/manage/member-levels/list'
  });
};

// 获取会员等级选项（用于下拉选择）
export const fetchMemberLevelOptions = () => {
  return service({
    method: 'get',
    url: '/manage/member-levels/options'
  });
};

// 获取会员等级背景图片列表
export const fetchMemberLevelBackgrounds = () => {
  return service({
    method: 'get',
    url: '/manage/member-levels/backgrounds/list'
  });
};

// 新增会员等级
export const addMemberLevel = (data) => {
  return service({
    method: 'post',
    url: '/manage/member-levels',
    data
  });
};

// 更新会员等级
export const updateMemberLevel = (id, data) => {
  return service({
    method: 'put',
    url: `/manage/member-levels/${id}`,
    data
  });
};

// 删除会员等级
export const deleteMemberLevel = (id) => {
  return service({
    method: 'delete',
    url: `/manage/member-levels/${id}`
  });
};

// 获取注册设置
export const getRegisterSettings = () => {
  return service({
    method: 'get',
    url: '/manage/settings/register'
  });
};

// 保存注册设置
export const saveRegisterSettings = (data) => {
  return service({
    method: 'post',
    url: '/manage/settings/register',
    data
  });
};

// 创建消费记录
export const createConsumption = (userId, data) => {
  return service({
    method: 'post',
    url: '/manage/consumptions',
    data: {
      user_id: userId,
      amount: data.amount,
      matter: data.matter,
      calculate_points: data.calculatePoints,
      order_number: data.orderNumber,
      remarks: data.remark
    }
  });
};

// 获取积分设置
export const fetchPointSettings = () => {
  return service({
    method: 'get',
    url: '/manage/points/settings'
  });
};

// 获取会员消费记录
export const getMemberConsumptions = (memberId, params = {}) => {
  return service({
    method: 'get',
    url: `/manage/member/${memberId}/consumptions`,
    params
  });
};

// 获取用户档案
export const fetchMemberProfile = (memberId) => {
  return service({
    method: 'get',
    url: `/manage/user-list/${memberId}/profile`
  });
};

// 更新用户档案
export const updateMemberProfile = (memberId, data) => {
  return service({
    method: 'put',
    url: `/manage/user-list/${memberId}/profile`,
    data
  });
};

// 获取用户档案图片列表
export const fetchMemberProfileImages = (memberId) => {
  return service({
    method: 'get',
    url: `/manage/user-list/${memberId}/profile-images`
  });
};

// 添加用户档案图片
export const addMemberProfileImage = (memberId, data) => {
  return service({
    method: 'post',
    url: `/manage/user-list/${memberId}/profile-images`,
    data
  });
};

// 删除用户档案图片
export const deleteMemberProfileImage = (memberId, imageId) => {
  return service({
    method: 'delete',
    url: `/manage/user-list/${memberId}/profile-images/${imageId}`
  });
};

// 获取会员统计数据
export const getMemberStatistics = (days = 30) => {
  return service({
    method: 'get',
    url: '/manage/member/statistics',
    params: {
      days: days
    }
  });
};

// 调整会员积分
export const adjustMemberPoints = (userId, data) => {
  return service({
    method: 'post',
    url: '/manage/points/adjust',
    data: {
      user_id: userId,
      type: data.type,
      amount: data.amount,
      reason: data.reason
    }
  });
};